/**
 * Короткое имя поставщика для выдачи в приложении.
 * «ИП Фамилия Имя Отчество» → «ИП Фамилия». Прочие имена не трогаем.
 */
export const shortenSupplierName = (name: string | null | undefined): string => {
  const value = (name ?? '').trim()
  const match = value.match(/^ИП\s+(\S+)/i)
  return match ? `ИП ${match[1]}` : value
}

/**
 * Отображаемое имя поставщика: явный ярлык, иначе сокращённое юр. имя.
 * Ярлык (displayLabel) — то, что пользователь сам задал, его не сокращаем.
 */
export const displaySupplierName = (
  displayLabel: string | null | undefined,
  legalName: string | null | undefined,
): string => displayLabel?.trim() || shortenSupplierName(legalName) || 'Поставщик'
